import styled from '@emotion/styled';
import { theme } from '../../../../theme';
import { NAVBAR_BREAKPOINT } from '../../ProductFrame.styled';
export const MenuBarContainer = styled.nav `
	padding: 0 0 ${theme.spacing.space20} 0;
	border-top: 1px solid ${theme.colors.LM_NU30};
	/* we don't currently have a token for this particular opacity of white */
	background-color: rgba(255,255,255,0.9);
	backdrop-filter: blur(3px);
	width: 100%;
	height: 100%;

	@media only screen and (min-width: ${NAVBAR_BREAKPOINT}) {
		display: none;
	}
	/*
	Styles for nested Unread components.
	Using interpolation to style them directly
	requires an additional emotion-babel plugin.
	*/
	.unread {
		position: absolute;
		top: ${theme.spacing.space10};
		margin-left: ${theme.spacing.space20};
		left: 50%;
	}
`;
export const MenuBar = styled.ul `
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	height: 100%;

	li {
		flex: 1;
		display: flex;
	}
`;
//# sourceMappingURL=MenuBar.styled.js.map